var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon--root icon--twitter",
    viewBox: "0 0 22 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.533 1.745s3.376 4.547 9.245 4.861c0 0-.795-2.686 1.642-4.74 2.437-2.057 5.45-.314 6.028.46 0 0 1.714-.272 2.911-1.09 0 0-.39 1.57-1.836 2.516 0 0 1.693-.23 2.477-.691 0 0-.826 1.343-2.25 2.37 0 0 .599 5.674-4.203 10.362C10.747 20.481 2.85 19.506 0 17.051c0 0 3.871.442 6.597-1.918 0 0-3.221-.064-4.15-3.116 0 0 1.61.127 1.89-.188 0 0-3.47-.849-3.5-4.532 0 0 1.052.536 2.013.568 0 0-3.346-2.455-1.317-6.12",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.46f2af8b.svg";
export { ForwardRef as ReactComponent };